import JobPost from '@/apps/job_post_v2/JobPost.vue';
import JobPostTypeOfCare from '@/apps/job_post_v2/JobPostTypeOfCare.vue';
import JobPostLocation from '@/apps/job_post_v2/JobPostLocation.vue';
import JobPostDetails from '@/apps/job_post_v2/JobPostDetails.vue';
import JobPostSchedule from '@/apps/job_post_v2/schedule/JobPostSchedule.vue';
import JobPostConfirm from '@/apps/job_post_v2/confirm/JobPostConfirm.vue';
import JobPostFamilyDetails from '@/apps/job_post_v2/JobPostFamilyDetails.vue';
import JobPostRates from '@/apps/job_post_v2/JobPostRates.vue';
import JobPostRequirements from '@/apps/job_post_v2/requirements/JobPostRequirements.vue';
import { requireSeeker } from '../guards/authGuards';

const jobPostRoutes = [
  {
    path: '/job-post',
    component: JobPost,
    beforeEnter: requireSeeker,
    children: [
      {
        path: 'location',
        name: 'job-post-location',
        component: JobPostLocation,
        meta: {
          stepLabel: 'Location',
        },
      },
      {
        path: 'select-schedule',
        name: 'job-post-select-schedule',
        component: JobPostTypeOfCare,
        meta: {
          stepLabel: 'Type of Care',
        },
      },
      {
        path: 'schedule',
        name: 'job-post-schedule',
        component: JobPostSchedule,
        meta: {
          stepLabel: 'Schedule',
        },
      },
      {
        path: 'family-details',
        name: 'job-post-family-details',
        component: JobPostFamilyDetails,
        meta: {
          stepLabel: 'Family',
        },
      },
      {
        path: 'rates',
        name: 'job-post-rates',
        component: JobPostRates,
        meta: {
          stepLabel: 'Rates',
        },
      },
      {
        path: 'requirements',
        name: 'job-post-requirements',
        component: JobPostRequirements,
        meta: {
          stepLabel: 'Requirements',
        },
      },
      {
        path: 'details',
        name: 'job-post-details',
        component: JobPostDetails,
        meta: {
          stepLabel: 'Details',
        },
      },
      { path: 'confirm', name: 'job-post-confirm', component: JobPostConfirm },
      { path: '*', redirect: { name: 'job-post-location' } },
      {
        path: '',
        redirect: { name: 'job-post-location' },
      },
    ],
  },
];

export default jobPostRoutes;
